import { Component, OnInit, ViewChild } from '@angular/core';
import { MapChart } from 'angular-highcharts';
import { HttpClient } from '@angular/common/http';
import { take, map, tap } from 'rxjs/operators';
import { LotePresupuesto } from 'src/app/models/entities/lote-presupuesto';
import { PresupuestoEstado } from 'src/app/models/entities/presupuesto-estado';
import { LotePresupuestoService } from 'src/app/services/lote-presupuesto.service';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { UnidadResponsable } from 'src/app/models/entities/unidad-responsable';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import { ReportePresupuestoService } from 'src/app/services/reporte-presupuesto.service';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'grafica-mapa',
  templateUrl: './grafica-mapa.component.html',
  styleUrls: ['./grafica-mapa.component.scss'],
  animations: [
    // the fade-in/fade-out animation.
    trigger('fadeIn', [

      // the "in" style determines the "resting" state of the element when it is visible.
      state('in', style({ opacity: 1 })),

      // fade in when created. this could also be written as transition('void => *')
      transition(':enter', [
        style({ opacity: 0 }),
        animate(300)
      ]),

      // fade out when destroyed. this could also be written as transition('void => *')
      transition(':leave',
        animate(300, style({ opacity: 0 })))
    ])
  ]
})
export class GraficaMapaComponent implements OnInit {
  @ViewChild('modalPresupuestos')
  public modalPresupuestos: any;
  // public data = [
  //   // ['mx-3622', 0],
  //   ['mx-bc', 0],
  //   ['mx-bs', 0],
  //   ['mx-so', 0],
  //   ['mx-cl', 0],
  //   ['mx-na', 0],
  //   ['mx-cm', 0],
  //   ['mx-qr', 0],
  //   ['mx-mx', 0],
  //   ['mx-mo', 0],
  //   ['mx-df', 0],
  //   ['mx-qt', 0],
  //   ['mx-tb', 0],
  //   ['mx-cs', 0],
  //   ['mx-nl', 0],
  //   ['mx-si', 0],
  //   ['mx-ch', 0],
  //   ['mx-ve', 0],
  //   ['mx-za', 0],
  //   ['mx-ag', 0],
  //   ['mx-ja', 0],
  //   ['mx-mi', 0],
  //   ['mx-oa', 0],
  //   ['mx-pu', 0],
  //   ['mx-gr', 0],
  //   ['mx-tl', 0],
  //   ['mx-tm', 0],
  //   ['mx-co', 0],
  //   ['mx-yu', 0],
  //   ['mx-dg', 0],
  //   ['mx-gj', 0],
  //   ['mx-sl', 0],
  //   ['mx-hg', 0]
  // ];

  public datos: any;

  public catUnidadesResponsables: UnidadResponsable[] = [];

  public mapChart: MapChart;

  public readonly CAMINOS_RURALES: string = '0';
  public readonly CARRETERAS_FEDERALES: string = '1';



  constructor(
    private http: HttpClient,
    private lotePresupuestoService: LotePresupuestoService,
    private catalogoService: CatalogoService,
    private reportePresupuestoService: ReportePresupuestoService) { }

  async ngOnInit() {
    await this.obtenerCatalogos();
    let datos: any[] = await this.cargarPresupuestosPorEstados();
    this.mapChart = new MapChart({
      chart: {
        map: await this.http.get('../../../../../assets/mapa-mexico/mapa-mexico.json').pipe(take(1)).toPromise(),
      },
      title: {
        text: 'PEF Estados (MDP)'
      },

      mapNavigation: {
        enabled: true,
        buttonOptions: {
          align: 'right',
          verticalAlign: 'bottom'
        }
      },

      colorAxis: {
        min: 1,
        labels: {
          format: '{value}'
        },
        stops: [
          [0, '#FFFFFF'],
          [1, '#a80229']
        ]
      },

      legend: {
        verticalAlign: 'top',
      },

      series: [{
        point: {
          events: {
            click: (event) => {
              this.abrirReportePresupuestoEstado(event.point['hc-key']);
            }
          }
        },
        data: datos,
        // name: 'Random data',
        states: {
          hover: {
            color: '#bb9767'
          }
        },
        dataLabels: {
          enabled: true,
          format: '{point.name}'
        },
        tooltip: {
          pointFormat: '{point.value}',
          valueSuffix: 'mdp'
        },
        name: 'PEF',
      }]
    } as any);
  }

  public async obtenerCatalogos(): Promise<void> {
    this.catUnidadesResponsables = await this.catalogoService.obtenerCatalogo<UnidadResponsable>(RutaCatalogoEnum.UNIDADES_RESPONSABLES).pipe(take(1)).toPromise();
  }

  public async abrirReportePresupuestoEstado(hcKey: string) {
    let lotesPresupuestos = [];
    let presupuestosRurales = [];
    let presupuestosFederales = [];
    let fechaCreacionRurales;
    let fechaCreacionFederales;
    let cveEstado: string = this.catUnidadesResponsables.find((ur: UnidadResponsable) => ur.hcKey === hcKey).cve.toString();
    lotesPresupuestos = await this.reportePresupuestoService.findByAnioPef(cveEstado).pipe(
      take(1)
    ).toPromise();
    for (let index = 0; index < lotesPresupuestos.length; index++) {
      for (let indice = 0; indice < lotesPresupuestos[index].lotePresupuestoEstado.presupuestosEstados.length; indice++) {
        if (lotesPresupuestos[index].lotePresupuestoEstado.presupuestosEstados[indice].ur === cveEstado && lotesPresupuestos[index].keyCatDireccionAdjunta === this.CAMINOS_RURALES) {
          presupuestosRurales.push(lotesPresupuestos[index].lotePresupuestoEstado.presupuestosEstados[indice]);
          fechaCreacionRurales = lotesPresupuestos[index].fechaCreacion;
        } else if (lotesPresupuestos[index].lotePresupuestoEstado.presupuestosEstados[indice].ur === cveEstado && lotesPresupuestos[index].keyCatDireccionAdjunta === this.CARRETERAS_FEDERALES) {
          presupuestosFederales.push(lotesPresupuestos[index].lotePresupuestoEstado.presupuestosEstados[indice]);
          fechaCreacionFederales = lotesPresupuestos[index].fechaCreacion;
        }
      }
    }
    let datosPresupuestos: any = [];
    datosPresupuestos.presupuestosRurales = presupuestosRurales;
    datosPresupuestos.presupuestosFederales = presupuestosFederales;
    datosPresupuestos.urEstado = {}
    datosPresupuestos.urEstado.estado = cveEstado;
    datosPresupuestos.fechaCreacionRurales = fechaCreacionRurales;
    datosPresupuestos.fechaCreacionFederales = fechaCreacionFederales;
    this.modalPresupuestos.abrirlModalPresupuestos(datosPresupuestos);
  }

  public cargarPresupuestosPorEstados(): Promise<any[]> {
    return this.lotePresupuestoService.findByKeyCatDireccion('0').pipe(
      take(1),
      map((lotePresupuesto: LotePresupuesto) => {
        let clavesUnidadesResponsables: string[] = [];
        clavesUnidadesResponsables = lotePresupuesto.lotePresupuestoEstado.presupuestosEstados.map((presupuestoEstado: PresupuestoEstado) => presupuestoEstado.ur);
        let clavesUnidadesResponsablesSinRepetir: string[] = (Array.from(new Set<string>(clavesUnidadesResponsables)));
        return clavesUnidadesResponsablesSinRepetir.map((ur: string) => {
          let pef: number = 0;
          lotePresupuesto.lotePresupuestoEstado.presupuestosEstados.filter((pe: PresupuestoEstado) => pe.ur === ur).forEach((pe: PresupuestoEstado) => {
            pef += pe.pef;
          });
          return [
            this.catUnidadesResponsables.find((unidadResp: UnidadResponsable) => unidadResp.cve.toString() === ur).hcKey,
            parseFloat(pef.toFixed(2))
          ]
        })
      })
    ).toPromise();
  }

}
